const RETURN_PATH_BASE_URL = "https://return-path.invalid";

function hasControlCharacter(value: string) {
  for (let index = 0; index < value.length; index += 1) {
    const code = value.charCodeAt(index);
    if (code < 32 || code === 127) return true;
  }
  return false;
}

/**
 * 同じオリジンのパスだけを戻り先として受ける。URLの解析で`/`と同じに扱われるバックスラッシュ
 * （`/\evil.example`）、解析で取り除かれる制御文字、`//`で始まる相対プロトコルの形を拒み、
 * 解決したオリジンが変わらないことも確かめる。
 */
export function normalizeAuthReturnPath(
  returnTo: string | null | undefined,
  fallback = "/",
) {
  if (
    !returnTo?.startsWith("/") ||
    returnTo.startsWith("//") ||
    returnTo.includes("\\") ||
    /%5c/iu.test(returnTo) ||
    hasControlCharacter(returnTo)
  ) {
    return fallback;
  }

  try {
    const parsed = new URL(returnTo, RETURN_PATH_BASE_URL);
    if (parsed.origin !== RETURN_PATH_BASE_URL) return fallback;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return fallback;
  }
}

export function buildAuthCallbackURL(
  returnTo: string | null | undefined,
  baseURL: string,
  fallback = "/",
) {
  const returnPath = normalizeAuthReturnPath(returnTo, fallback);

  try {
    return new URL(returnPath, baseURL).href;
  } catch {
    return new URL(fallback, baseURL).href;
  }
}
